import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MdDialog, MdDialogConfig } from '@angular/material';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { ConstantsService } from 'app/services/constants-service';
import { SnackBarService } from 'app/services/snackbar.service';
import { AuthenticationGuard } from 'app/services/authentication-guard.service';
import { EntityMonitoringService } from 'app/entities/monitoring/entity-monitoring.service';
import { RelatedEntitiesTrackingDialogComponent } from './related-entities-tracking-dialog/related-entities-tracking-dialog.component';

interface EntityWithPendingHits {
  entityId: number;
  entityName: string;
  openHitCount: number;
  sanctionCount?: number;
  pepCount?: number;
  badPressCount?: number;
}

@Component({
  selector: 'app-pending-hits-overview',
  templateUrl: './pending-hits-overview.component.html',
  styleUrls: ['./pending-hits-overview.component.css']
})
export class PendingHitsOverviewComponent implements OnInit {
  entities: EntityWithPendingHits[] = [];
  loading = false;
  totalEntities = 0;
  deletingAllOpenHits = false;

  constructor(
    private requestService: ObservableRequestService,
    private snackBarService: SnackBarService,
    private router: Router,
    private dialog: MdDialog,
    private authenticationGuard: AuthenticationGuard,
    private entityMonitoringService: EntityMonitoringService
  ) {}

  ngOnInit() {
    this.loadEntitiesWithPendingHits();
  }

  loadEntitiesWithPendingHits() {
    this.loading = true;
    const url = ConstantsService.MONITORING_ENTITIES_WITH_PENDING_HITS;

    this.requestService.getRequest(url).subscribe(
      (response: any) => {
        this.loading = false;
        try {
          if (response && response.arrResult) {
            const result = response.arrResult;
            if (result && Array.isArray(result.entities)) {
              this.entities = result.entities;
              this.totalEntities = result.totalEntities != null ? result.totalEntities : result.entities.length;
            } else if (result && typeof result === 'object') {
              this.entities = result.entities || [];
              this.totalEntities = result.totalEntities || 0;
            } else {
              this.entities = [];
              this.totalEntities = 0;
            }
          } else if (response && Array.isArray(response.entities)) {
            this.entities = response.entities;
            this.totalEntities = response.totalEntities != null ? response.totalEntities : response.entities.length;
          } else {
            this.entities = [];
            this.totalEntities = 0;
          }
        } catch (e) {
          console.error('Error parsing response:', e, response);
          this.entities = [];
          this.totalEntities = 0;
          this.snackBarService.showSimpleMsj('Error parsing response: ' + (e.message || 'Unknown error'));
        }
      },
      error => {
        this.loading = false;
        console.error('Error loading entities with pending hits:', error);
        this.snackBarService.showSimpleMsj('Error loading entities with pending hits: ' + (error.message || 'Unknown error'));
        this.entities = [];
        this.totalEntities = 0;
      }
    );
  }

  navigateToEntity(entity: EntityWithPendingHits) {
    this.router.navigate(['/entity', entity.entityId, 'monitoring']);
  }

  refresh() {
    this.loadEntitiesWithPendingHits();
  }

  openRelatedEntitiesTracking() {
    const config = new MdDialogConfig();
    config.width = '1000px';
    config.disableClose = false;
    this.dialog.open(RelatedEntitiesTrackingDialogComponent, config);
  }

  isAdminUser(): boolean {
    return this.authenticationGuard && this.authenticationGuard.isAdminUser();
  }

  deleteAllOpenHits() {
    if (!this.isAdminUser() || this.deletingAllOpenHits || this.loading) {
      return;
    }
    if (this.totalEntities === 0) {
      this.snackBarService.showSimpleMsj('No open hits to delete.');
      return;
    }
    const openTotal = this.entities.reduce(
      (sum, e) => sum + (e.openHitCount || 0), 0);
    const confirmMsg =
      'Delete all ' + openTotal + ' open monitoring hit(s) across '
      + this.totalEntities + ' entit'
      + (this.totalEntities === 1 ? 'y' : 'ies')
      + '? Resolved history is kept. This cannot be undone.';
    if (!confirm(confirmMsg)) {
      return;
    }
    this.deletingAllOpenHits = true;
    this.entityMonitoringService.deleteAllOpenHits().subscribe(
      response => {
        this.deletingAllOpenHits = false;
        const ok = response && response.flagResult;
        this.snackBarService.showSimpleMsj(
          ok
            ? ((response && response.message) || 'All open hits deleted.')
            : ((response && response.message) || 'Delete failed.'));
        if (ok) {
          this.refresh();
        }
      },
      err => {
        this.deletingAllOpenHits = false;
        this.snackBarService.showSimpleMsj(
          (err && err.message) || 'Failed to delete open hits.');
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/pending-hits-overview/pending-hits-overview.component.ts